import AudioEngine, { getAudioPath } from '@/webgl/audio/AudioEngine'
import AudioBundle from '@/webgl/audio/resources/AudioBundle'
import ILoadable from '@/webgl/runner/interfaces/ILoadable'
import { AudioSetup, AudioSetupEntry, SupportedLocales } from '@/webgl/runner/scenarios/ScenarioSetup.types'

export default class ScenarioAudio implements ILoadable {
  bundle: AudioBundle | null = null

  constructor(
    readonly locale: SupportedLocales,
    readonly voices: AudioSetup,
    readonly sfx: AudioSetupEntry
  ) {
    this.bundle = AudioEngine.createBundle()
    this.bundle.addSprite(getAudioPath(voices[locale].path), getAudioPath(voices[locale].subtitles))

    this.bundle.addSprite(getAudioPath(sfx.path))
  }

  load(abort: AbortSignal): Promise<unknown> {
    if (!this.bundle) return Promise.resolve()
    return this.bundle.load(abort)
  }

  dispose() {
    this.bundle?.dispose()
    this.bundle = null
  }
}
